import React from "react";
import ChartGoal from "charts/ChartGoal";
import ChartLine from "charts/ChartLine";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import MetricFormatter from "dashboards/MetricFormatter";
import MetricTablePdf from "MetricTablePdf";
import GetFormatter from "dashboards/GetFormatter";
import jsDig from "utils/jsDig";
import allMetrics from "data/allMetrics.js";
import { camelCase, cloneDeep } from "lodash-es";
import getNegative from "../utils/getNegative";
import getGoalLocked from "utils/getGoalLocked";
import dashboardTableOrder from "../utils/dashboardTableOrder";
const allMetricData = allMetrics();
export default function MonthlyPpcSection(props) {
  const section = props.section;
  let cc_data = props[`${props.section.service}_section`].cc_data;
  const baseCurrency = jsDig([`${props.section.service}_section`, 'base_currency'], props)
  const displayCurrency = jsDig([`${props.section.service}_section`, 'display_currency'], props)
  const dashboard = props.dashboard;
  const metricData = allMetricData["metricData"];
  const goalChartDim = "120x120";
  const lineChartDim = "350x250";
  const goalsPerRow = 5;
  const chartsPerRow = 2;
  const tablesPerRow = 1;

  let date = props.date ? moment(props.date) : moment();
  let month = date.format("MMM");
  let year = date.year();
  function categorize(string) {
    if (string.includes("campaignGroups")) {
      campaignGroupCase = string;
    }
    return string;
  }
  if (section.metrics_data) {
    const renderArray = dashboardTableOrder("ppc", Object.keys(section.metrics_data));
    switch (categorize(section.name)) {
      case "goalsAndProjections":
        let goals = props[`${props.section.service}_section`].goals;
        return (
          <>
            {props.sectionIndex == 0 && (
              <div style={{ justifyContent: "space-between", display: "flex" }}>
                <h2 className="page-header ppc-color off-color-bg" style={{ textAlign: "left" }}>
                  KPI's vs Goals{" "}
                </h2>
                <ul style={{ listStyle: "none" }}>
                  <li>{props.client_name}</li>
                  <li>{props.date_formatted}</li>
                </ul>
              </div>
            )}
            <Row xs={goalsPerRow} style={{ margin: "auto", display: "block" }}>
              <h5 style={{ textAlign: "left", color: "#3291C1", marginTop: "10px" }} className={`${section.service == "seo" ? "seo-color" : "ppc-color"}`}>
                {section.service == "ppc" ? "All PPC" : section.service == "seo" ? "SEO" : capitalize(section.service)}
              </h5>
              <div style={{ display: "flex" }}>
                {renderArray.map((metricName, index) => {
                  const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                  if (metricKey) {
                    const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                    const current = jsDig([dashboard, metricKey, "raw"], cc_data);
                    const goal = parseFloat(jsDig([dashboard, year, month, camelCase(metricKey)], goals));
                    const projected = jsDig([dashboard, metricKey, "projected"], cc_data);
                    const negative = getNegative(section.name, metricKey, projected - goal, cc_data);
                    const goalLocked = getGoalLocked(date, metricKey);
                    let Formatter = GetFormatter({ metricName: metricKey });

                    return (
                      <Col key={index} style={{ marginTop: "10px" }}>
                        {jsDig([dashboard, metricKey, "raw"], cc_data) != null && section.metrics_data[metricName] == "1" ? (
                          <ChartGoal
                            metricName={metricShortened}
                            current={current}
                            goal={goal}
                            projected={projected}
                            formatter={Formatter}
                            negative={negative}
                            goalLocked={goalLocked}
                            pdfDim={goalChartDim}
                            baseCurrency={baseCurrency}
                            displayCurrency={displayCurrency}
                          />
                        ) : (
                          <p className="text-danger" key={index}>
                            {metricKey} was not found in cc_data
                          </p>
                        )}
                      </Col>
                    );
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricName} not defined in metricData.json
                      </p>
                    );
                  }
                })}
              </div>
            </Row>
          </>
        );
      case "primaryKpiCharts":
        return (
          <>
            {props.sectionIndex == 0 && (
              <div style={{ justifyContent: "space-between", display: "flex", marginBottom: "20px" }}>
                <h2 className="page-header ppc-color off-color-bg" style={{ textAlign: "left" }}>
                  PPC Performance: {props.section.service == "ppc" ? "All PPC" : capitalize(props.section.service)}
                </h2>
                <ul style={{ listStyle: "none" }}>
                  <li>{props.client_name}</li>
                  <li>{props.date_formatted}</li>
                </ul>
              </div>
            )}
            {props.sectionIndex == 1 && props.section.service == "ppc" && <h2 style={{ textAlign: "center" }}>PPC Performance: All PPC</h2>}
            <h3 className="ppc-color">Primary KPI's (charts)</h3>

            <Row sm={chartsPerRow} className="justify-content-center">
              {renderArray.map((metricName, index) => {
                const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                const metricShortened = jsDig([metricName, "name", "shortened"], metricData);
                if (metricKey) {
                  if (jsDig([dashboard, "metrics_by_months", metricKey], cc_data) != null) {
                    if (section.metrics_data[metricName] == "1") {
                      let Formatter = GetFormatter({ metricName: metricKey, tick: true });
                      return (
                        <Col className="mb-4" key={index}>
                          <ChartLine
                            metricName={metricShortened}
                            currentYear={jsDig([dashboard, "metrics_by_months", metricKey, 0, "year"], cc_data)}
                            currentYearData={jsDig([dashboard, "metrics_by_months", metricKey, 0, "data"], cc_data)}
                            previousYear={jsDig([dashboard, "metrics_by_months", metricKey, 1, "year"], cc_data)}
                            previousYearData={jsDig([dashboard, "metrics_by_months", metricKey, 1, "data"], cc_data)}
                            tickFormatter={Formatter}
                            baseCurrency={baseCurrency}
                            displayCurrency={displayCurrency}
                            pdfDim={lineChartDim}
                          />
                        </Col>
                      );
                    }
                  } else {
                    return (
                      <p className="text-danger" key={index}>
                        {metricKey} was not found in metrics_by_month in cc_data
                      </p>
                    );
                  }
                } else {
                  return (
                    <p className="text-danger" key={index}>
                      {metricName} not defined in metricData.json
                    </p>
                  );
                }
              })}
            </Row>
          </>
        );
      case "primaryKpiTables":
        let metricTitles = [];
        return (
          <>
            {props.sectionIndex == 0 && (
              <div style={{ justifyContent: "space-between", display: "flex", marginBottom: "20px" }}>
                <h2 className="page-header ppc-color off-color-bg" style={{ textAlign: "left" }}>
                  PPC Performance: {props.section.service == "ppc" ? "All PPC" : capitalize(props.section.service)}
                </h2>
                <ul style={{ listStyle: "none" }}>
                  <li>{props.client_name}</li>
                  <li>{props.date_formatted}</li>
                </ul>
              </div>
            )}
            <h3 className="ppc-color">Primary KPI's (tables) </h3>
            <Row sm={tablesPerRow} className="justify-content-center">
              {renderArray.map((metricName, index) => {
                const metricKey = jsDig([metricName, "name", "snakeCase"], metricData);
                if (metricKey) {
                  metricTitles.push(metricKey);
                  if (jsDig([dashboard, "metrics_2_years", metricKey], cc_data) == null) {
                    return (
                      <p className="text-danger" key={index}>
                        {metricKey} was not found in metrics_2_years in cc_data
                      </p>
                    );
                  }
                } else {
                  return (
                    <p className="text-danger" key={index}>
                      {metricName} not defined in metricData.json
                    </p>
                  );
                }
              })}

              {[...Array(Math.ceil(metricTitles.length / 4))].map((x, index) => {
                return (
                  <Col className="skinny-table" key={index}>
                    <MetricTablePdf
                      table={jsDig([dashboard, "metrics_2_years"], cc_data)}
                      client={props.client}
                      headerOrder={metricTitles.splice(0, 4)}
                      date={props.date}
                      scrollMessage={false}
                      responsive={false}
                      baseCurrency={baseCurrency}
                      displayCurrency={displayCurrency}
                    />
                  </Col>
                );
              })}
            </Row>
          </>
        );

      default:
        return (
          <>
            <h4 className="text-danger">{section.name} is not a valid section name for this dashboard</h4>
          </>
        );
    }
  }
}
